import { z } from "zod";

export const customerFormSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  phoneCountryCode: z.string(),
  phoneNumber: z.string().min(8, "Phone number must be at least 8 digits"),
  marketingConsent: z.boolean(),
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: "You must accept the terms of service",
  }),
  promoCode: z.string().optional(),
});

export type CustomerFormData = z.infer<typeof customerFormSchema>;